module.exports = __webpack_public_path__ + "static/media/ic_desktop_logo.6d53b5bf.svg";